// Application entrypoint that initializes providers and routing.
import { QueryClientProvider } from '@tanstack/react-query'
import { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import VConsole from 'vconsole'

import {
  ConfirmModalProvider,
  ErrorBoundary,
  NotificationProvider,
  TooltipProvider,
} from '@maxus/website/components'
import { env } from '@maxus/website/constants/env.ts'
import { GlobalContext } from '@maxus/website/contexts'
import { queryClient } from '@maxus/website/lib'

import { router } from './router'

import './index.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import './index.less'
import './i18n'

if (env.VITE_NODE_ENV === 'development') {
  new VConsole()
}

if (env.VITE_APP_TARGET === 'electron') {
  document.documentElement.dataset.appTarget = 'electron'
}

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <Suspense>
      <QueryClientProvider client={queryClient}>
        <GlobalContext>
          <TooltipProvider delayDuration={150}>
            <ConfirmModalProvider>
              <NotificationProvider>
                <RouterProvider router={router} />
              </NotificationProvider>
            </ConfirmModalProvider>
          </TooltipProvider>
        </GlobalContext>
      </QueryClientProvider>
    </Suspense>
  </ErrorBoundary>,
)
